import styleConstants from './constants';
const addAlpha = (hexCode, alpha) => {
    let rgbaColor;
    try {
        let tempHex = hexCode.replace('#', '');
        if (tempHex.length === 3) {
            tempHex += tempHex;
        }
        const r = parseInt(tempHex.substring(0, 2), 16);
        const g = parseInt(tempHex.substring(2, 4), 16);
        const b = parseInt(tempHex.substring(4, 6), 16);
        rgbaColor = `rgba(${r},${g},${b},${alpha})`;
    }
    catch (error) {
        rgbaColor = hexCode;
    }
    return rgbaColor;
};
const getFontStyles = (text) => (`
  color: ${text.color};
  color: #${text.color};
  font-size: ${text.size.web};
  font-family: ${text.fontFamily};
  letter-spacing: ${text.letterSpacing.web};
  font-weight: ${text.fontWeight || 500};
  text-align:${text.alignment};
  line-height: initial !important;
`);
const getIndividualBorderRadius = (borderRadius) => {
    const { topLeft, topRight, bottomRight, bottomLeft, } = borderRadius;
    return (`
  border-top-left-radius: ${topLeft === null || topLeft === void 0 ? void 0 : topLeft.web};
  border-top-right-radius: ${topRight === null || topRight === void 0 ? void 0 : topRight.web};
  border-bottom-right-radius: ${bottomRight === null || bottomRight === void 0 ? void 0 : bottomRight.web};
  border-bottom-left-radius: ${bottomLeft === null || bottomLeft === void 0 ? void 0 : bottomLeft.web}; 
`);
};
const getIndividualBorder = (border) => {
    var _a, _b, _c, _d;
    const { top, right, bottom, left, } = border;
    return (`
    border-top: ${(_a = top === null || top === void 0 ? void 0 : top.width) === null || _a === void 0 ? void 0 : _a.web} solid ${addAlpha(top === null || top === void 0 ? void 0 : top.color, top === null || top === void 0 ? void 0 : top.alpha)};
    border-right: ${(_b = right === null || right === void 0 ? void 0 : right.width) === null || _b === void 0 ? void 0 : _b.web} solid ${addAlpha(right === null || right === void 0 ? void 0 : right.color, right === null || right === void 0 ? void 0 : right.alpha)};
    border-left: ${(_c = left === null || left === void 0 ? void 0 : left.width) === null || _c === void 0 ? void 0 : _c.web} solid ${addAlpha(left === null || left === void 0 ? void 0 : left.color, left === null || left === void 0 ? void 0 : left.alpha)};
    border-bottom: ${(_d = bottom === null || bottom === void 0 ? void 0 : bottom.width) === null || _d === void 0 ? void 0 : _d.web} solid ${addAlpha(bottom === null || bottom === void 0 ? void 0 : bottom.color, bottom === null || bottom === void 0 ? void 0 : bottom.alpha)};
  `);
};
const getMarginStyles = (margin) => (`
  margin: ${margin.top.web} ${margin.right.web} ${margin.bottom.web} ${margin.left.web}
`);
const getPaddingStyles = (padding) => (`
  padding: ${padding.top.web} ${padding.right.web} ${padding.bottom.web} ${padding.left.web}
`);
const getBorderStyles = (border) => {
    const borderColor = border.color || '#fff';
    const borderWidth = border.width.web || 0;
    /**
     * @description This case is added if border alpha is 0 previously.
     * @case previously condition is  border.alpha || 1.
     * if alpha is 0 its cosider the value 1 means border are visible even if the alpha value 0.
     */
    const borderAlpha = ((border === null || border === void 0 ? void 0 : border.alpha) || (border === null || border === void 0 ? void 0 : border.alpha) === 0) ? border.alpha : 1;
    return (`
    border: ${borderWidth} solid ${addAlpha(borderColor, borderAlpha)};
  `);
};
const getBKGStyles = (bkg) => `
background: linear-gradient(${bkg === null || bkg === void 0 ? void 0 : bkg.degree}deg, ${addAlpha(bkg === null || bkg === void 0 ? void 0 : bkg.colorStart, bkg === null || bkg === void 0 ? void 0 : bkg.alpha)}, ${addAlpha((bkg === null || bkg === void 0 ? void 0 : bkg.colorEnd) ? bkg === null || bkg === void 0 ? void 0 : bkg.colorEnd : bkg === null || bkg === void 0 ? void 0 : bkg.colorStart, bkg === null || bkg === void 0 ? void 0 : bkg.alpha)});
`;
/**
 * @abstract this is used to set the visibility of the container
 * @param visible
 * @returns display none if visible is false and if true display nothing beacuse it takes the
 * display cascade property.
 */
const setVisibility = (visible) => `
  display:  ${!(visible) ? 'none !important' : ''} ;
`;
/**
 * @abstract this function should use the iconsKeyMapping and whatever
 * icon is coming from template builder just @returns to the SDK
 * @todo mask-size: would be dynamic in  future
 */
const getIcon = (iconType) => `
mask-image:  url(${styleConstants.IMAGE_STATIC_URL}${styleConstants.iconsKeyMapping[iconType]});
mask-repeat: no-repeat;
mask-position: center;
mask-size: 24px 24px;
`;
export default {
    getFontStyles,
    getMarginStyles,
    getPaddingStyles,
    getBKGStyles,
    getBorderStyles,
    getIndividualBorderRadius,
    getIndividualBorder,
    addAlpha,
    setVisibility,
    getIcon,
};
